const customMode = (arr) => {
  if (!arr) {
    return undefined;
  }
  const cloneArr = arr.map((_) => Object.assign({}, _));
  cloneArr.sort((a, b) => a.value - b.value);
  const obj = cloneArr
    .sort(
      (a, b) =>
        cloneArr.filter((v) => v.value === a.value).length -
        cloneArr.filter((v) => v.value === b.value).length
    )
    .pop();
  return obj ? obj.value : undefined;
};

export default class PropertyInfo {
  constructor(
    address,
    structures,
    parcels,
    tax,
    scraper,
    estimatedPremium,
    crimeGrade
  ) {
    this.apn = address.apn;
    this.formatted_street_address = address.formatted_street_address;
    this.city = address.city;
    this.state = address.state;
    this.zip_code = address.zip_code;
    this.county = address.county;
    this.unit_type = address.unit_type;
    this.estimated_premium_2500 = estimatedPremium["2500"].total;
    this.estimated_premium_2500_water_backup =
      estimatedPremium["2500_water_backup"].total;
    this.estimated_premium_5000 = estimatedPremium["5000"].total;
    this.estimated_premium_5000_water_backup =
      estimatedPremium["5000_water_backup"].total;
    this.swimming_pool = (scraper.amenities || {}).swimming_pool || false; // Can probably break this out by listing
    this.building_website_meta = scraper.building_website_meta || [];
    this.property_type_meta = scraper.property_type_meta || [];
    this.number_buildings_meta = scraper.number_buildings_meta || [];
    this.number_units_meta = scraper.number_units_meta || [];
    this.bed_meta = scraper.bed_meta || [];
    this.bed_meta = [
      ...this.bed_meta,
      { value: structures.beds_count, listing_url: "https://estated.com/" },
    ].filter((_) => _.value);
    this.bath_meta = scraper.bath_meta || [];
    this.bath_meta = [
      ...this.bath_meta,
      { value: structures.baths, listing_url: "https://estated.com/" },
    ].filter((_) => _.value);
    this.partial_bath_meta = scraper.partial_bath_meta || [];
    this.partial_bath_meta = [
      ...this.partial_bath_meta,
      {
        value: structures.partial_baths_count,
        listing_url: "https://estated.com/",
      },
    ].filter((_) => _.value);
    this.sqft_meta = scraper.sqft_meta || [];
    this.sqft_meta = [
      ...this.sqft_meta,
      {
        value: structures.total_area_sq_ft,
        listing_url: "https://estated.com/",
      },
    ].filter((_) => _.value);
    this.year_built_meta = scraper.year_built_meta || [];
    this.year_built_meta = [
      ...this.year_built_meta,
      { value: structures.year_built, listing_url: "https://estated.com/" },
    ].filter((_) => _.value);
    this.number_stories_meta = scraper.number_stories_meta || [];
    this.number_stories_meta = [
      ...this.number_stories_meta,
      { value: structures.stories, listing_url: "https://estated.com/" },
    ].filter((_) => _.value);
    this.pet_policy_meta = scraper.pet_policy_meta || [];
    this.management_company_meta = scraper.management_company_meta || [];
    this.estimated_value_meta = scraper.estimated_value_meta || [];
    this.estimated_rent_meta = scraper.estimated_rent_meta || [];
    this.basement_meta = scraper.basement_meta || [];
    this.basement_meta = [
      ...this.basement_meta,
      { value: structures.basement_type, listing_url: "https://estated.com/" },
    ].filter((_) => _.value);
    this.last_sold_price_meta = scraper.last_sold_price_meta || [];
    this.last_sold_date_meta = scraper.last_sold_date_meta || [];
    this.monthly_hoa_meta = scraper.monthly_hoa_meta || [];
    this.estimated_annual_tax_meta = scraper.estimated_annual_tax_meta || [];
    this.estimated_annual_tax_meta = [
      ...this.estimated_annual_tax_meta,
      { value: tax.amount, listing_url: "https://estated.com/" },
    ].filter((_) => _.value);
    this.lot_size_meta = scraper.lot_size_meta || [];
    this.lot_size_meta = [
      ...this.lot_size_meta,
      { value: parcels.area_sq_ft, listing_url: "https://estated.com/" },
    ].filter((_) => _.value);
    this.roof_type_meta = scraper.roof_type_meta || [];
    this.roof_type_meta = [
      ...this.roof_type_meta,
      {
        value: [structures.roof_material_type].filter((_) => _),
        listing_url: "https://estated.com/",
      },
    ].filter((_) => _.value.length);
    this.exterior_construction_meta = scraper.exterior_construction_meta || [];
    this.exterior_construction_meta = [
      ...this.exterior_construction_meta,
      {
        value: [structures.exterior_wall_type].filter((_) => _),
        listing_url: "https://estated.com/",
      },
    ].filter((_) => _.value.length);
    this.foundation_type_meta = [
      {
        value: structures.foundation_type,
        listing_url: "https://estated.com/",
      },
    ].filter((_) => _.value);
    this.quality_meta = [
      { value: structures.quality, listing_url: "https://estated.com/" },
    ].filter((_) => _.value);
    this.condition_meta = [
      { value: structures.condition, listing_url: "https://estated.com/" },
    ].filter((_) => _.value);
    this.walk_score_meta = scraper.walk_score_meta || [];
    this.transit_score_meta = scraper.transit_score_meta || [];
    this.schools = scraper.schools || [];
    this.crime_grade = crimeGrade;
    this.fire_risk_meta = scraper.fire_risk_meta;
    this.flood_risk_meta = scraper.flood_risk_meta;
    this.heat_risk_meta = scraper.heat_risk_meta;
  }

  get building_website() {
    return customMode(this.building_website_meta);
  }
  get property_type() {
    return customMode(this.property_type_meta);
  }
  get number_buildings() {
    return customMode(this.number_buildings_meta);
  }
  get number_units() {
    return customMode(this.number_units_meta);
  }
  get bed() {
    return customMode(this.bed_meta);
  }
  get bath() {
    return customMode(this.bath_meta);
  }
  get partial_bath() {
    return customMode(this.partial_bath_meta);
  }
  get sqft() {
    return customMode(this.sqft_meta);
  }
  get year_built() {
    return customMode(this.year_built_meta);
  }
  get number_stories() {
    return customMode(this.number_stories_meta);
  }
  get pet_policy() {
    return customMode(this.pet_policy_meta);
  }
  get management_company() {
    return customMode(this.management_company_meta);
  }
  get estimated_value() {
    return customMode(this.estimated_value_meta);
  }
  get estimated_rent() {
    return customMode(this.estimated_rent_meta);
  }
  get basement() {
    return customMode(this.basement_meta);
  }
  get last_sold_price() {
    return customMode(this.last_sold_price_meta);
  }
  get last_sold_date() {
    return customMode(this.last_sold_date_meta);
  }
  get monthly_hoa() {
    return customMode(this.monthly_hoa_meta);
  }
  get estimated_annual_tax() {
    return customMode(this.estimated_annual_tax_meta);
  }
  get lot_size() {
    return customMode(this.lot_size_meta);
  }
  get roof_type() {
    return new Array(...new Set(this.roof_type_meta.flatMap((_) => _.value)));
  }
  get exterior_construction() {
    return new Array(
      ...new Set(this.exterior_construction_meta.flatMap((_) => _.value))
    );
  }
  get foundation_type() {
    return customMode(this.foundation_type_meta);
  }
  get quality() {
    return this.quality_meta.map((_) => _.value);
  }
  get condition() {
    return this.condition_meta.map((_) => _.value);
  }
  get walk_score() {
    return customMode(this.walk_score_meta);
  }
  get transit_score() {
    return customMode(this.transit_score_meta);
  }
  get fire_risk() {
    return customMode(this.fire_risk_meta);
  }
  get flood_risk() {
    return customMode(this.flood_risk_meta);
  }
  get heat_risk() {
    return customMode(this.heat_risk_meta);
  }
}
